import { render, staticRenderFns } from "./Chamados.vue?vue&type=template&id=0215f197&scoped=true"
import script from "./Chamados.vue?vue&type=script&lang=js"
export * from "./Chamados.vue?vue&type=script&lang=js"
import style0 from "./Chamados.vue?vue&type=style&index=0&id=0215f197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215f197",
  null
  
)

export default component.exports